export const appConfig = {
	displayFormDebug: true
};
